import { grantExpForUser } from "@/game/model/grant-exp";
import { applyWalletGrant, createDefaultHomeEconomy } from "@/home/economy";
import { loadHomeEconomyFromIdb, saveHomeEconomyToIdb } from "@/home/home-idb";

/** Repeat raid clear on same defender floor — same idea as tower repeat XP. */
export const DUNGEON_REPEAT_REWARD_FACTOR = 0.7;

/** Gold per 1 EXP granted (after repeat factor). */
export const DUNGEON_GOLD_PER_EXP = 0.3;

export type DungeonBattleRewardInput = {
  baseXp: number;
  trial: boolean;
  repeatClear: boolean;
};

export type DungeonBattleRewardTotals = {
  exp: number;
  gold: number;
  repeatClear: boolean;
};

export function computeDungeonBattleRewards(
  input: DungeonBattleRewardInput,
): DungeonBattleRewardTotals {
  if (input.trial || input.baseXp <= 0) {
    return { exp: 0, gold: 0, repeatClear: false };
  }
  const repeatClear = input.repeatClear;
  const factor = repeatClear ? DUNGEON_REPEAT_REWARD_FACTOR : 1;
  const exp = Math.max(0, Math.floor(input.baseXp * factor));
  const gold = Math.max(0, Math.floor(exp * DUNGEON_GOLD_PER_EXP));
  return { exp, gold, repeatClear };
}

export async function applyDungeonBattleRewards(
  userId: string,
  rewards: DungeonBattleRewardTotals,
): Promise<void> {
  if (rewards.exp <= 0 && rewards.gold <= 0) return;
  if (rewards.exp > 0) grantExpForUser(userId, rewards.exp);
  if (rewards.gold > 0) {
    const economy = (await loadHomeEconomyFromIdb(userId)) ?? createDefaultHomeEconomy();
    const next = applyWalletGrant(economy, { coins: rewards.gold });
    await saveHomeEconomyToIdb(userId, next);
  }
}
